var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBhvr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 273.24,
    viewBox: "0 0 300 273.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54.45 -510.122)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    transform: "translate(-1280.965 -14578.65) scale(14.65291)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M111.61 1048.393H91.136v-18.647h20.474v18.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.162 1042.715h8.37v-2.314h-5.68v-1.968h5.06v-2.08h-5.06v-1.81h5.537v-2.152h-8.227v10.324zm-3.89-5.844c1.084 0 1.46 1.059 1.46 2.014 0 1.025-.376 2.165-1.476 2.165-1.114 0-1.487-.851-1.487-2.165 0-1.55.838-2.014 1.503-2.014m-3.876 5.844h2.343v-.868h.03c.475.708 1.2 1.083 2.067 1.083 2.356 0 3.353-2.024 3.353-4.137 0-1.947-1.04-3.8-3.165-3.8-.925 0-1.633.348-2.142 1.04h-.025v-3.642h-2.46v10.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.998 1044.263c0 .19-.095.297-.336.297h-.435v-.587h.447c.233 0 .324.116.324.29m.796 1.792l-.537-1.026c.296-.134.486-.385.486-.786 0-.637-.421-.875-1.05-.875h-1.203v2.687h.737v-.906h.297l.438.906h.832zm-2.641-1.15v-1.537h-.758v1.537c0 .334-.126.534-.415.534-.292 0-.423-.2-.423-.534v-1.537h-.758v1.537c0 .856.494 1.194 1.17 1.194.675 0 1.184-.338 1.184-1.194m-3.355-.19c0 .484-.169.733-.464.733-.302 0-.477-.26-.477-.742s.167-.733.467-.733c.3 0 .474.26.474.742m.774-.01c0-.892-.51-1.381-1.238-1.381-.731 0-1.247.499-1.247 1.39 0 .895.508 1.384 1.237 1.384.73 0 1.248-.5 1.248-1.393m-2.749-1.339h-.759v2.687h.759v-2.687zm-.97 0h-.829l-.196.72c-.093.342-.223.88-.273 1.14-.048-.26-.178-.805-.273-1.14l-.195-.72h-.834l.921 2.688h.754l.925-2.688zm-3.34 1.623h-.444l.05-.174c.096-.345.136-.491.174-.671.032.18.076.322.17.671l.05.174zm1.134 1.065l-.975-2.688h-.752l-.976 2.688h.799l.145-.473h.806l.146.473h.807zm-2.894 0v-2.688h-.759v.978h-.837v-.978h-.76v2.688h.76v-1.06h.837v1.06h.759z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhvr);
export default __webpack_public_path__ + "static/media/bhvr.92baf43ee8f8ce5ace3f303fc68e0b58.svg";
export { ForwardRef as ReactComponent };